import type { AdminHomeLink, FeatureRoute } from '@/shared/registry'

import { companiesPath, companyRoute, createCompanyPath, editCompanyRoute, readCompaniesPermission, writeCompaniesPermission } from './paths'

/** What other features use of companies: a company's page and read permission, and companies' names by id. */
export { companyPath, readCompaniesPermission } from './paths'
export { useCompanyNames } from './use-company-names'

/** Find Companies, Company Details, and Create and Edit Company (SM-22). */
export const companyRoutes: readonly FeatureRoute[] = [
  {
    path: companiesPath,
    titleId: 'siteManagement.companies.find.title',
    page: () => import('./FindCompaniesPage').then((module) => module.FindCompaniesPage),
  },
  {
    path: createCompanyPath,
    titleId: 'siteManagement.companies.create.title',
    page: () => import('./CompanyFormPages').then((module) => module.CreateCompanyPage),
  },
  {
    path: companyRoute,
    titleId: 'siteManagement.companies.details.title',
    page: () => import('./CompanyDetailsPage').then((module) => module.CompanyDetailsPage),
  },
  {
    path: editCompanyRoute,
    titleId: 'siteManagement.companies.edit.title',
    page: () => import('./CompanyFormPages').then((module) => module.EditCompanyPage),
  },
]

/** Find and Create Company on Admin Home, with the users. */
export const companyAdminHomeLinks: readonly AdminHomeLink[] = [
  { id: 'find-companies', category: 'users', labelId: 'siteManagement.companies.find.title', path: companiesPath, permission: readCompaniesPermission },
  { id: 'create-company', category: 'users', labelId: 'siteManagement.companies.create.title', path: createCompanyPath, permission: writeCompaniesPermission },
]
